module.exports = __webpack_public_path__ + "img/nssb.7c196f81.svg";